import React from "react";
import PropTypes from "prop-types";
import { CFontIcon, Text, Flex } from "@appcues/component-library";

const DomainItem = ({ isInstalled, metaDomain, noCheckBox = false }) => {
  const displayedWithCheckBox = !noCheckBox;
  const altText = isInstalled
    ? "icon indicating domain is installed"
    : "icon indicating domain is not installed";
  const iconColor = isInstalled ? "$green" : "$gray-3";
  const textColor = isInstalled ? "inherit" : "$gray-3";

  return (
    <Flex alignItems="center">
      {displayedWithCheckBox && (
        <Text color={textColor} isInstalled={isInstalled}>
          {metaDomain}
        </Text>
      )}
      <CFontIcon
        className={"fas fa-circle"}
        altText={altText}
        marginLeft="8px"
        fontSize="12px"
        color={iconColor}
      />
      {noCheckBox && (
        <Text marginLeft="0.5em" color={textColor} isInstalled={isInstalled}>
          {metaDomain}
        </Text>
      )}
    </Flex>
  );
};

DomainItem.propTypes = {
  isInstalled: PropTypes.bool.isRequired,
  metaDomain: PropTypes.string.isRequired,
  noCheckBox: PropTypes.bool
};

export default DomainItem;
